import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { LuDatetimePickerConfig } from 'lu-datetime-picker';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'lu-datetime-formly-picker',
	templateUrl: './lu-datetime-formly-picker.component.html'
})
export class LuDatetimeFormlyPickerComponent extends FieldType implements OnInit {
	componentOptions: LuDatetimePickerConfig = {} as LuDatetimePickerConfig;

	ngOnInit(): void {
		this.componentOptions.placeholderFrom = this.to.luPlaceholderFrom;
		this.componentOptions.placeholderTo = this.to.luPlaceholderTo;
		this.componentOptions.disabled = !!this.to.disabled;
		this.componentOptions.displayClearButton = !!this.to.displayClearButton;
		this.componentOptions.dateRange = this.to.luDateRange;
		this.componentOptions.minValue = this.to.luMinValue;
		this.componentOptions.maxValue = this.to.luMaxValue;
		this.componentOptions.readonly = this.to.readonly;
		this.componentOptions.inlineDatePicker = this.to.inlineDatePicker;
		this.componentOptions.labelDatePicker = this.to.labelDatepicker;
		this.componentOptions.labelDateRangeTo = this.to.labelDateRangeTo;
		this.componentOptions.dateOnly = this.to.dateOnly;
		this.componentOptions.dateFormat = this.to.dateFormat;
		this.componentOptions.labelTimePicker = this.to.labelTimePicker;
		this.componentOptions.labelTimePickerTo = this.to.labelTimePickerTo;
		this.componentOptions.primaryId = this.field.id;
		this.componentOptions.primaryTimePickerId = `${this.field.id}-timepicker`;
		this.componentOptions.secondaryId = `${this.field.id}-to`;
		this.componentOptions.secondaryTimePickerId = `${this.field.id}-secondary-timepicker`;
		this.componentOptions.required = this.to.required;

		if (this.to.placement) {
			this.componentOptions.placement = this.to.placement;
		}

		if (this.to.hasOwnProperty('primaryRequired')) {
			this.componentOptions.primaryRequired = this.to.primaryRequired;
		}

		if (this.to.hasOwnProperty('secondaryRequired')) {
			this.componentOptions.secondaryRequired = this.to.secondaryRequired;
		}

		if (this.to.primaryRequiredMessage) {
			this.componentOptions.primaryRequiredMessage = this.to.primaryRequiredMessage;
		}

		if (this.to.secondaryRequiredMessage) {
			this.componentOptions.secondaryRequiredMessage = this.to.secondaryRequiredMessage;
		}

		if (!!this.to.luTimeOptions) {
			this.componentOptions.timeOptions = this.to.luTimeOptions;
		}

		if (this.to.luHideTimepicker) {
			this.componentOptions.hideTimepicker = this.to.luHideTimepicker;
		}

		if (this.to.luHideDatepicker) {
			this.componentOptions.hideDatepicker = this.to.luHideDatepicker;
		}

		if (this.to.localeDateTime) {
			this.componentOptions.localeDateTime = this.to.localeDateTime;
		}
	}

	ready($event): void {
		if (!!this.to && !!this.to.ready) {
			this.to.ready($event);
		}
	}

	change($event): void {
		if (!!this.to && !!this.to.change) {
			this.to.change($event);
		}
	}
}
